<template>
  <div class="alert" :class="alertClass" role="alert" v-if="show">
    <slot>
      <h4 v-if="isDefault || showHeader" class="alert-heading"><span><img v-if="isDefault" src="@/assets/info.svg" class="info align-middle" /></span><span class="align-middle">{{ title }}</span></h4>
      <p class="mb-0">{{ message }}</p>
      <p class="mb-0"></p>
    </slot>
  </div>
</template>

<script>
// https://getbootstrap.com/docs/4.3/components/alerts/
/**
 * success
 * warning
 * danger
 * primary
 */
export default {
  props: ['show', 'title', 'message', 'type', 'showHeader'],
  data () {
    return {

    };
  },
  computed: {
    alertClass () {
      if (!this.type) return 'alert-primary';
      if (this.type) return `alert-${this.type}`;
    },
    isDefault () {
      return (!this.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
</style>
